import { Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

/** antd preset colour per flow execution status; shared by every execution view. */
export const EXECUTION_STATUS_TAG_COLORS: Record<string, string> = {
  STARTED: 'processing',
  COMPLETED: 'success',
  FAILED: 'error'
};

/**
 * Flow execution status tag (running / completed / failed) with a matching icon.
 * Unknown statuses render as a neutral tag with the raw value.
 */
export function ExecutionStatusTag({ status }: { status: string }) {
  const { t } = useTranslation('admin');
  const icon =
    status === 'FAILED' ? <CloseCircleOutlined /> : status === 'COMPLETED' ? <CheckCircleOutlined /> : status === 'STARTED' ? <SyncOutlined spin /> : undefined;

  return (
    <Tag color={EXECUTION_STATUS_TAG_COLORS[status] ?? 'default'} icon={icon} style={{ marginInlineEnd: 0 }}>
      {t(`logs.status.${status}`, { defaultValue: status })}
    </Tag>
  );
}
